import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ADM, GFE, GFO, GFE_CONSULTA, GFO_CONSULTA } from '~/constants/perfil';

import { UnidataTable, Modal } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoCotaDistribVeiculo,
  recordFiltering,
} from '~/store/modules/operacaocotadistribveiculo/actions';
import { isNull } from 'lodash';

import { Visibility } from '@material-ui/icons';

import DetalheJustificativa from './DetalheJustificativa';

function OperacaoCotaDistribVeiculo() {
  const { profile } = useSelector((state) => state.user);

  const modalJusRef = useRef(null);

  const operacaocotadistribveiculo = useSelector(
    (state) => state.operacaocotadistribveiculo
  );

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
        case GFO:
        case GFE_CONSULTA:
        case GFO_CONSULTA:
          break;
        default:
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const header = useMemo(
    () => [
      {
        id: 'orga_codigo',
        label: 'Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Descrição Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_codigo',
        label: 'Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Descrição Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'veic_placa_apresentacao',
        label: 'Placa',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'prod_descricao',
        label: 'Produto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'cove_cota',
        label: 'Cota',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'cove_saldo',
        label: 'Saldo',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {

        id: 'cove_justificativa',
        label: 'Justificativa',
        formatted: (value) => value && value.length > 10 ? value.substring(0, 5) + '...' : value,
      }
    ],
    []
  );

  const buttons = useMemo(() => [
    {

      title: 'Visualizar Justificativa',
      action: (value) => modalJusRef.current.handleOpenModal({ data: value }),
      icon: <Visibility />,
    }

  ], [])

  const actionsModalObs = useMemo(() => [{
    label: 'Fechar',
    color: 'secondary',
    callback: () => modalJusRef.current.handleCloseModal(),
  }], [modalJusRef])

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="orga_codigo, unid_codigo, veic_placa  ASC"
        create={false}
        delete={false}
        update={false}
        title={'Visualizar Cota Veículo'}
        fixed
        header={header}
        find={findOperacaoCotaDistribVeiculo}
        redux={operacaocotadistribveiculo}
        read={recordFiltering}
        detach="orga_nome"
        keys={['orga_codigo', 'unid_codigo', 'veic_placa']}
        view="VW_COTA_VEICULO"
        reportTitle="Visualizar Cota Veículo"
        actions={buttons}
      />

      <Modal
        ref={modalJusRef}
        component={DetalheJustificativa}
        title="Justificativa"
        maxWidth="sm"
        actions={actionsModalObs}
      />
    </>
  );
}

export default OperacaoCotaDistribVeiculo;
